import React from 'react';
import { css } from 'linaria';

const ProductLogoCSS = css`
  display: flex;
  img {
    width: 108px;
  }
`;

const ProductLogo = ({ product }) => {
  const getBrandNameFriendlyPath = name => {
    return name
      .toLowerCase()
      .replace(/ä|å|á|à/gi, 'a')
      .replace(/é|è|ë/gi, 'e')
      .replace(/ö|ô|ø/gi, 'o')
      .replace(/ |-/gi, '_')
      .replace(/\W/g, '')
      .replace(/_/gi, '-');
  };

  const brandField = product?.customFields?.find(
    field => field.key === 'Tillverkare'
  );
  const brandPath = brandField
    ? getBrandNameFriendlyPath(brandField.stringValue)
    : '';

  const productLogo =
    'https://rinab2.jetshop.se/admin/pub_images/original/' + brandPath + '.jpg';

  const [imageError, setImageError] = React.useState(true);
  const [mountedImage, setMountedImage] = React.useState(false);

  React.useEffect(() => {
    const brandImg = document.createElement('img');

    brandImg.addEventListener('error', () => {
      setImageError(true);
      setMountedImage(true);
    });

    brandImg.addEventListener('load', () => {
      setImageError(false);
      setMountedImage(true);
    });

    brandImg.src = productLogo;
  }, [productLogo]);

  if (!mountedImage || imageError) {
    return null;
  }

  return (
    <div className={ProductLogoCSS}>
      <img loading="lazy" src={productLogo} alt={product.subName} />
    </div>
  );
};

export default ProductLogo;
